import { debounce } from 'lodash';

export default {
  data() {
    return {
      editedIndex: -1,
      loading: false,
      items: [],
      options: {
        page: 1,
        itemsPerPage: 15,
        sortBy: [{ key: 'id', order: 'desc' }],
      },
      footerProps: {
        showCurrentPage: true,
        showFirstLastPage: true,
        itemsPerPageOptions: [15, 25, 50, 100],
      },
      search: '',
      totalItems: 0,
    };
  },
  computed: {
    sortParams() {
      // Handle Vuetify 3 format: sortBy is an array of {key, order} objects
      const sortByArray = this.options.sortBy;

      // Check if sortBy exists and has items
      if (!sortByArray || sortByArray.length === 0) {
        // Default to id desc if no sort is specified
        return {
          sortBy: ['id'],
          sortDesc: [true],
        };
      }

      const firstSort = sortByArray[0];

      // Check if it's Vuetify 3 format (object with key and order)
      if (firstSort && typeof firstSort === 'object' && firstSort.key) {
        return {
          sortBy: [firstSort.key],
          sortDesc: [firstSort.order === 'desc'],
        };
      }

      // Fallback: if it's a string (old Vuetify 2 format)
      if (typeof firstSort === 'string') {
        return {
          sortBy: [firstSort],
          sortDesc: this.options.sortDesc || [true],
        };
      }

      // Final fallback
      return {
        sortBy: ['id'],
        sortDesc: [true],
      };
    },
  },
  methods: {
    // Debounce will not work with an arrow function
    // eslint-disable-next-line func-names
    searchTable: debounce(function () {
      this.updateTable();

      this.options.page = 1;
    }, 500),
  },
};
